import React, { useState, useEffect } from 'react';
import { db } from '../firebase/firebase-config';
import { collection, addDoc, getDocs, query, limit } from 'firebase/firestore';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, Phone, Mail, Loader2, CheckCircle, Linkedin, Facebook, Instagram, MessageCircle } from 'lucide-react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './ContactPage.css';
/* DİL SİSTEMİ İMPORTU */
import { useLanguage } from '../../context/LanguageContext';

const ContactPage = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [status, setStatus] = useState('');
  const [contactInfo, setContactInfo] = useState(null);
  
  /* Dil beynini bağladık kanka */
  const { lang, t } = useLanguage();

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const querySnapshot = await getDocs(query(collection(db, "settings"), limit(1)));
        if (!querySnapshot.empty) {
          setContactInfo(querySnapshot.docs[0].data());
        }
      } catch (error) {
        console.error("Bilgiler getirilemedi:", error);
      }
    };
    fetchSettings();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');

    const whatsappNumber = contactInfo?.phone?.replace(/\s/g, '') || "905520262568";
    
    // WhatsApp mesaj şablonunu dile göre (TR, EN, AR) dinamik yapıyoruz kanka
    const text = lang === 'TR' 
      ? `*Bigma Yem - Yeni İletişim Formu*%0A%0A` +
        `*Ad Soyad:* ${formData.name}%0A` +
        `*Telefon:* ${formData.phone}%0A` +
        `*Konu:* ${formData.subject}%0A` +
        `*Mesaj:* ${formData.message}`
      : lang === 'AR'
      ? `*بيغما للأعلاف - نموذج اتصال جديد*%0A%0A` +
        `*الاسم واللقب:* ${formData.name}%0A` +
        `*الهاتف:* ${formData.phone}%0A` +
        `*الموضوع:* ${formData.subject}%0A` +
        `*الرسالة:* ${formData.message}`
      : `*Bigma Feed - New Contact Form*%0A%0A` +
        `*Name Surname:* ${formData.name}%0A` +
        `*Phone:* ${formData.phone}%0A` +
        `*Subject:* ${formData.subject}%0A` +
        `*Message:* ${formData.message}`;

    try {
      await addDoc(collection(db, "messages"), { ...formData, createdAt: new Date() });
      window.open(`https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${text}`, '_blank');
      setStatus('success');
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
      setTimeout(() => setStatus(''), 5000);
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="contact-page-wrapper">
      <Navbar />

      <section className="contact-hero-new">
        <div className="contact-hero-blur"></div>
        <div className="container hero-inner">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} className="hero-text-content">
            <span className="contact-mini-label">{t('contact.badge')}</span>
            <h1>
              {lang === 'TR' ? "Sizinle İletişimde Kalmak " : lang === 'AR' ? "البقاء على تواصل معك أمر " : "Staying in Touch with You is "}
              <span>{lang === 'TR' ? "Önemli." : lang === 'AR' ? "مهم." : "Important."}</span>
            </h1>
            <p>
              {lang === 'TR' 
                ? "Bigma besleme uzmanlarımız ve teknik ekibimiz sorularınızı yanıtlamak için hazır." 
                : lang === 'AR'
                ? "خبراء التغذية والفريق الفني في بيغما جاهزون للإجابة على أسئلتك."
                : "Our Bigma nutrition experts and technical team are ready to answer your questions."}
            </p>
          </motion.div>
        </div>
      </section>

      <section className="contact-body-section">
        <div className="container">
          <div className="contact-glass-grid">
            
            <div className="contact-info-cards">
              <div className="info-card-modern">
                <div className="card-icon-box"><MapPin size={24} /></div>
                <div className="card-text">
                  <h3>{lang === 'TR' ? "Fabrika & Merkez" : lang === 'AR' ? "المصنع والمقر الرئيسي" : "Factory & Headquarters"}</h3>
                  <p>
                    {contactInfo?.address 
                      ? (lang === 'TR' ? contactInfo.address : lang === 'AR' ? `${contactInfo.address} / تركيا` : `${contactInfo.address} / Turkey`)
                      : (lang === 'TR' ? "Adres yükleniyor..." : lang === 'AR' ? "جاري تحميل العنوان..." : "Loading address...")}
                  </p>
                </div>
              </div>

              <div className="info-card-modern">
                <div className="card-icon-box"><Phone size={24} /></div>
                <div className="card-text">
                  <h3>{lang === 'TR' ? "Hızlı İletişim" : lang === 'AR' ? "اتصال سريع" : "Quick Contact"}</h3>
                  <p>{contactInfo?.phone || "0346 218 18 25"}</p>
                </div>
              </div>

              <div className="info-card-modern">
                <div className="card-icon-box"><Mail size={24} /></div>
                <div className="card-text">
                  <h3>{lang === 'TR' ? "E-Posta" : lang === 'AR' ? "البريد الإلكتروني" : "E-Mail"}</h3>
                  <p>{contactInfo?.email || "info@bigmagrup.com.tr"}</p>
                </div>
              </div>

              <div className="social-wrap-contact">
                <h4>{lang === 'TR' ? "Sosyal Medyada Bigma" : lang === 'AR' ? "بيغما على وسائل التواصل الاجتماعي" : "Bigma on Social Media"}</h4>
                <div className="social-row">
                  <a href={contactInfo?.instagram || "#"} target="_blank" rel="noreferrer" className="social-icon-btn"><Instagram size={20}/></a>
                  <a href={contactInfo?.linkedin || "#"} target="_blank" rel="noreferrer" className="social-icon-btn"><Linkedin size={20}/></a>
                  <a href={contactInfo?.facebook || "#"} target="_blank" rel="noreferrer" className="social-icon-btn"><Facebook size={20}/></a>
                </div>
              </div>
            </div>

            <motion.div initial={{ opacity: 0, scale: 0.95 }} whileInView={{ opacity: 1, scale: 1 }} className="contact-form-premium">
              <div className="form-header">
                <h2>{lang === 'TR' ? "Mesajınızı İletin" : lang === 'AR' ? "أرسل رسالتك" : "Send Your Message"}</h2>
                <div className="form-line"></div>
              </div>

              <form onSubmit={handleSubmit} className="bigma-form">
                <div className="form-row-multi">
                  <div className="form-group-new">
                    <label>{lang === 'TR' ? "Adınız Soyadınız" : lang === 'AR' ? "الاسم واللقب" : "Your Name Surname"}</label>
                    <input type="text" placeholder={lang === 'TR' ? "Tam adınızı yazın" : lang === 'AR' ? "اكتب اسمك الكامل" : "Write your full name"} required value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} />
                  </div>
                  <div className="form-group-new">
                    <label>{lang === 'TR' ? "E-Posta Adresiniz" : lang === 'AR' ? "عنوان البريد الإلكتروني" : "Your E-Mail Address"}</label>
                    <input type="email" placeholder={lang === 'TR' ? "E-posta adresinizi yazın" : lang === 'AR' ? "اكتب عنوان بريدك الإلكتروني" : "Write your e-mail address"} required value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} />
                  </div>
                </div>

                <div className="form-row-multi">
                  <div className="form-group-new">
                    <label>{lang === 'TR' ? "Telefon" : lang === 'AR' ? "الهاتف" : "Phone"}</label>
                    <input type="tel" placeholder="05xx xxx xx xx" required value={formData.phone} onChange={e => setFormData({...formData, phone: e.target.value})} />
                  </div>
                  <div className="form-group-new">
                    <label>{lang === 'TR' ? "Konu" : lang === 'AR' ? "الموضوع" : "Subject"}</label>
                    <input type="text" placeholder={lang === 'TR' ? "İletişim konusu nedir?" : lang === 'AR' ? "ما هو موضوع الاتصال؟" : "What is the subject?"} required value={formData.subject} onChange={e => setFormData({...formData, subject: e.target.value})} />
                  </div>
                </div>

                <div className="form-group-new">
                  <label>{lang === 'TR' ? "Mesajınız" : lang === 'AR' ? "رسالتك" : "Your Message"}</label>
                  <textarea placeholder={lang === 'TR' ? "Sorularınızı veya taleplerinizi buraya yazabilirsiniz..." : lang === 'AR' ? "يمكنك كتابة أسئلتك أو طلباتك هنا..." : "You can write your questions or requests here..."} rows={5} required value={formData.message} onChange={e => setFormData({...formData, message: e.target.value})} />
                </div>

                <button type="submit" className={`contact-btn-new ${status === 'loading' ? 'loading' : ''}`} disabled={status === 'loading'}>
                  {status === 'loading' ? <Loader2 className="animate-spin" /> : <><MessageCircle size={18}/> {lang === 'TR' ? "WP ile Gönder" : lang === 'AR' ? "إرسال عبر واتساب" : "Send via WP"}</>}
                </button>

                <AnimatePresence>
                  {status === 'success' && (
                    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="success-notif">
                      <CheckCircle size={18} /> {lang === 'TR' ? "Mesajınız kaydedildi ve WP'ye yönlendirildi!" : lang === 'AR' ? "تم حفظ رسالتك وتوجيهك إلى واتساب!" : "Your message is saved and redirected to WP!"}
                    </motion.div>
                  )}
                </AnimatePresence>
              </form>
            </motion.div>
          </div>

          {/* HARİTA ALANI */}
          {contactInfo?.mapIframe && (
            <div className="map-wrapper-modern">
               <iframe 
                src={contactInfo.mapIframe} 
                className="google-iframe"
                allowFullScreen="" 
                loading="lazy" 
                title={lang === 'TR' ? "Bigma Grup Konumu" : lang === 'AR' ? "موقع مجموعة بيغما" : "Bigma Group Location"}
                referrerPolicy="no-referrer-when-downgrade">
               </iframe>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;